export default function goTo(url, isReplace = false){
    if (!url) {
        return
    }
    if (typeof history.pushState !== 'undefined') {
        if(isReplace){
            history.replaceState(null, document.title, url)
        }else{
            history.pushState(null, document.title, url)
        }
    } else {
        window.location.assign(url)
    }
}
